import React, { useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const NewEmployeesChart = ({ series, categories }) => {
  const newEmployeesData = series.find(s => s.name === "New Employees")?.data || [];
  const chartContainerRef = useRef(null);
  
  useEffect(() => {
    if (chartContainerRef.current) {
      chartContainerRef.current.scrollLeft = chartContainerRef.current.scrollWidth;
    }
  }, [categories]);

  const data = {
    labels: categories,
    datasets: [
      {
        label: "New Employees",
        data: newEmployeesData,
        borderColor: "#00A86B",
        backgroundColor: "#00A86B",
        borderWidth: 3,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4, // For smooth curve similar to ApexCharts
        datalabels: {
          align: 'top',
          formatter: (value) => (value === 0 ? "" : value)
        }
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      
        
        enabled: true
      },
      datalabels: {
        color: '#000',
        font: {
          size: 12,
          weight: 'bold'
        },
        display: (context) => context.dataset.data[context.dataIndex] !== 0
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12
          },
          minRotation: 45,
          maxRotation: 45
        }
      },
      y: {
        title: {
          display: true,
          text: "Number of Employees"
        }
      }
    }
  };

  return (
    <div ref={chartContainerRef} style={{ marginBottom: "30px", overflowX: "auto", overflowY: "hidden", whiteSpace: "nowrap" }}>
      <div style={{ width: `${categories.length * 50}px`, minWidth: "600px", height: "290px" }}>
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default NewEmployeesChart;
